import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import {Validator} from 'vee-validate'
import {BasicSelect} from 'vue-search-select'
import VueElementLoading from 'vue-element-loading';
import MasterService from './../../../services/masterdata.service';

export default {
  name: 'createbox',
  components: {
    Paginate,
    BasicSelect,
    VueElementLoading
  },
  props: ['selectedEditRowData','stackinglevellist','boxstrengthlist'],
  data () {
    return {
      isLoading:false,
      updateID:'',
      boxtype:'',
      description:'',
      stackinglevel:'',
      stackinglevelitem:{value:'',text:''},
      boxstrengthitem:{value:'',text:''},
      boxstrength:'',
      userName:'',
      boxtypeData:'',
      product:"",
      breadth:"",
      length:"",
      height:"",
      avgweightperbox:"",
      disableBoxType: false,
      //dimension :[]
    }
  },
  computed: {

  },
  mounted () {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    if(this.stackinglevellist.length==0){
      this.getAllBoxStackingLevels();
    }
    if(this.boxstrengthlist.length==0){
      this.getAllBoxStrengths();
    }

    if(this.selectedEditRowData.id){
      this.updateID = this.selectedEditRowData.id;
      this.boxtype = this.selectedEditRowData.boxtype;
      this.stackinglevel = this.selectedEditRowData.stackinglevel;
      this.boxstrength = this.selectedEditRowData.boxstrength;
      this.description = this.selectedEditRowData.boxtypedescription;
      this.product = this.selectedEditRowData.product;
      this.breadth = this.selectedEditRowData.dimensions.B;
      this.length = this.selectedEditRowData.dimensions.L;
      this.height = this.selectedEditRowData.dimensions.H;
      this.avgweightperbox = this.selectedEditRowData.averagephysicalweight;
      this.stackinglevelitem = {
        value:this.selectedEditRowData.stackinglevel,
        text:this.selectedEditRowData.stackinglevel
      }
      this.boxstrengthitem = {
        value:this.selectedEditRowData.boxstrength,
        text:this.selectedEditRowData.boxstrength
      }
      this.disableBoxType = true;
    }
  },
  methods: {

    isNumber: function(evt) {
			evt = (evt) ? evt : window.event;
			var charCode = (evt.which) ? evt.which : evt.keyCode;
			if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
			  evt.preventDefault();;
			} else {
			  return true;
			}
	   },
    showCreateBoxData() {
      this.$emit("goBackToParent")
    },
    selectedStackingLevel(stackinglevelitem){
      this.stackinglevelitem = stackinglevelitem
      this.stackinglevel=stackinglevelitem.value
    },
    selectedBoxStrength(boxstrengthitem){
      this.boxstrengthitem = boxstrengthitem
      this.boxstrength=boxstrengthitem.value
    },
    async getAllBoxStackingLevels(){
      try {
        let InputPayload = {};
        this.isLoading = true;
        let result = await MasterService.getAllBoxStackingLevels(InputPayload);
        let stackinglevellist = result.data.data;
        for (var i = 0; i < stackinglevellist.length; i++) {
          this.stackinglevellist.push({
            'value': stackinglevellist[i].variantvalue,
            'text': stackinglevellist[i].variantvalue
          })
        }
        this.isLoading = false;
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    async getAllBoxStrengths(){
      try {
        let InputPayload = {};
        this.isLoading = true;
        let result = await MasterService.getAllBoxStrengths(InputPayload);
        let boxstrengthlist = result.data.data;
        for (var i = 0; i < boxstrengthlist.length; i++) {
          this.boxstrengthlist.push({
            'value': boxstrengthlist[i].variantvalue,
            'text': boxstrengthlist[i].variantvalue
          })
        }
        this.isLoading = false;
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    getStackingLevelName(stackingid) {
      for (var i = 0; i < this.stackinglevellist.length; i++) {
        if (this.stackinglevellist[i].value == stackingid) {
          return this.stackinglevellist[i].text;
        }
      }
    },
    getBoxStrenghtName(boxstrengthid) {
      for (var i = 0; i < this.boxstrengthlist.length; i++) {
        if (this.boxstrengthlist[i].value == boxstrengthid) {
          return this.boxstrengthlist[i].text;
        }
      }
    },
    async SaveBoxType(){
      try {
        var inputPayload = {};
        if(this.updateID){
          inputPayload.boxtypeid = this.updateID;
        }
        let dimenArr = []
        dimenArr.push({"B" :this.breadth,"L":this.length,"H":this.height
      })
        inputPayload.dimensionsdata = dimenArr;
        inputPayload.boxtypename = this.boxtype.trim();
        inputPayload.boxtypedescription = this.description.trim();
        inputPayload.product = this.product.trim();
        inputPayload.stackinglevel = this.stackinglevel;
        inputPayload.averagephysicalweight = this.avgweightperbox;
        inputPayload.boxstrength = this.boxstrength;
        inputPayload.lastmodifiedby = this.userName;
       this.isLoading = true;
        let result = await MasterService.saveBoxType(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.$alert(result.data.message, this.boxtype, "success");
          this.$emit("goBackToParent");
        }else{
          this.$alert(result.data.message, this.boxtype, "error");
        }

      } catch(err){
        this.isLoading = false;
        this.$alert(err, this.slabName, "error");
        console.log(err);
      }
    },
    onSubmit: function() {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.SaveBoxType(event);
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
    isNumber: function(evt, inputtype) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        if (inputtype == 'length' && ((this.length.indexOf('.') != -1) && (this.length.substring(this.length.indexOf('.')).length > 2))) {
          evt.preventDefault();
        } else if (inputtype == 'breadth' && ((this.breadth.indexOf('.') != -1) && (this.breadth.substring(this.breadth.indexOf('.')).length > 2))) {
          evt.preventDefault();
        } else if (inputtype == 'height' && ((this.height.indexOf('.') != -1) && (this.height.substring(this.height.indexOf('.')).length > 2))) {
          evt.preventDefault();
        }
        return true;
      }
    },
    handleBlur(e) {
      this.product = this.product.toLowerCase().replace(/(^\w{1})|(\s{1}\w{1})/g, match => match.toUpperCase());
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/BoxType/createbox/createbox.component.js